<h2>{{'order_management_header' | translate}}</h2>
<app-orders-management></app-orders-management>